import { useEffect, useRef, useState } from 'react';
import { PlaybackEvent, PlaybackEventEmitter } from '@annunciate/core';
import { chapterLocator, } from '../../utils';
export const useChapterData = (chapters) => {
    const ref = useRef(undefined);
    const [duration, setDuration] = useState();
    const [chapterLengthMap, setChapterLengthMap,] = useState([]);
    const [chapterLocation, setChapterLocation,] = useState();
    useEffect(() => {
        if (!duration)
            return;
        const map = [];
        for (let i = 0; i < chapters.length; i++) {
            const chapter = chapters[i];
            const nextLocation = chapters[i + 1] ? chapters[i + 1].location : duration;
            map.push({
                ...chapter,
                duration: nextLocation - chapter.location,
            });
        }
        setChapterLengthMap(map);
    }, [
        duration,
        chapters?.[0].id,
    ]);
    useEffect(() => {
        const listener = async (p) => {
            const chapter = chapterLocator(chapters, p.position);
            if (ref.current?.chapterId !== chapter.current.id) {
                setChapterLocation(chapter);
            }
            if (ref.current?.duration !== p.duration) {
                setDuration(p.duration);
            }
            ref.current = {
                duration,
                chapterId: chapter?.current?.id,
            };
        };
        PlaybackEventEmitter.on(PlaybackEvent.PROGRESS_UPDATED, listener);
        return () => {
            PlaybackEventEmitter.off(PlaybackEvent.PROGRESS_UPDATED, listener);
        };
    }, [
        chapters?.[0].id,
    ]);
    return {
        chapterLocation,
        chapterLengthMap,
    };
};
//# sourceMappingURL=useChapterData.js.map